<template>
  <div
      class="d-flex position-relative flex-grow-1 h-0 flex-column gmb-l-layout"
      :style="backgroundImagePath ? { backgroundImage: 'url(' + backgroundImagePath + ')' } : {}"
  >
    <div class="d-flex z-index-0 position-relative flex-grow-1 h-0 flex-column">
      <slot/>
    </div>

    <div
        v-if="hasModal"
        class="d-flex position-absolute z-index-1 flex-colummn"
    >
      <div class="d-flex position-relative flex-column">
        <slot name="modal"/>
      </div>
    </div>
  </div>
</template>

<script>
import {hasEnrichedSlot} from "@/helpers.js";

export default {
  name: "GmbLayout",

  components: {},

  props: {
    backgroundImagePath: String,
  },

  data() {
    return {};
  },

  computed: {
    hasModal() {
      return hasEnrichedSlot(this, "modal");
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
